import script from "./SchemaUsers.vue?vue&type=script&setup=true&lang=ts"
export * from "./SchemaUsers.vue?vue&type=script&setup=true&lang=ts"

import "./SchemaUsers.vue?vue&type=style&index=0&id=0342f555&lang=css"

const __exports__ = script;

export default __exports__